import React, { useState } from "react";
import { Global, css } from "@emotion/react";

import {
  Box,
  Text,
  Select,
  Divider,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
  Spinner,
  Grid,
  GridItem,
  Input,
} from "@chakra-ui/react";

import supportedToken from "utils/supportTokenList";
import supportedFarm, { supportFarmList } from "utils/supportFarmList";

const Dexscreener = (props) => {
  const [selectedToken, setSelectedToken] = useState(
    "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
  );

  return (
    <Box display="flex" width="100%" maxWidth="80vw" flexDir="column" py={10}>
      <Global
        styles={css`
          #dexscreener-embed {
            position: relative;
            width: 100%;
            padding-bottom: 125%;
          }
          @media (min-width: 1400px) {
            #dexscreener-embed {
              padding-bottom: 65%;
            }
          }
          #dexscreener-embed iframe {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            border: 0;
          }
        `}
      />
      <Select
        placeholder="Select Token"
        size="lg"
        color="white"
        border="2px solid rgb(140, 140, 227)"
        onChange={(e) => {
          setSelectedToken(e.target.value);
        }}
        defaultValue={selectedToken}
        mb={3}
      >
        {supportedToken.tokens.map((token) => (
          <option
            key={token.contractTickerSymbol}
            value={token.contractAddress}
          >
            {`${token.contractTickerSymbol} (${token.contractAddress})`}
          </option>
        ))}

        {supportFarmList.tokens.map((token) => (
          <option key={token.name} value={token.lpAddress}>
            {`${token.name} (${token.lpAddress})`}
          </option>
        ))}
      </Select>

      <div id="dexscreener-embed">
        <iframe
          src={`https://dexscreener.com/avalanche/${selectedToken}?embed=1&theme=dark`}
        />
      </div>
    </Box>
  );
};

export default Dexscreener;
